import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DropshippingWebsiteDevelopmentInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Dropshipping Website Development in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Start Selling Smart</Subheading>}
        heading={
          <Heading>
            Dropshipping <span tw="text-primary-500">Website Development</span>{" "}
            in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in dropshipping website development in
            **Dubai**, creating streamlined, efficient online stores that let
            you sell without inventory. Launch your dropshipping business with
            ease.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1484807352052-23338990c6c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce store visuals
          "https://images.unsplash.com/photo-1580674285054-bed31e145f59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Shipping/logistics visuals
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Digital business working
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Dropshipping Success in Dubai"
        description="We build websites optimized for dropshipping."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Inventory-Free",
            description: "Sell products without stocking them.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Setup",
            description: "Launch your store in record time.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Supplier Integration",
            description: "Seamless connection to suppliers.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Payments",
            description: "Safe transactions for all users.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Ready",
            description: "Optimized for shopping on the go.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Dubai’s dropshipping specialists.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Dropshipping Development Process"
        description={
          <Description>
            We craft your dropshipping store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define your dropshipping vision.</li>
              <li>Design: Build an intuitive, buyer-friendly site.</li>
              <li>Development: Integrate supplier and payment systems.</li>
              <li>Testing: Ensure smooth order fulfillment.</li>
              <li>Launch: Go live with a ready-to-sell store.</li>
              <li>Support: Provide ongoing optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Online shopping
          "https://images.unsplash.com/photo-1566002181046-b3f5025e8f80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Boxes/dropshipping visuals
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Dropshipping Wins in Dubai"
        description="Our stores fuel dropshipping success."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Generated 100+ sales in first month.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Launch",
            description: "Store live in just 7 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "98% approval from dropshippers.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Dropship?</Subheading>}
        heading="Dropshipping Website Development in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for dropshipping website development in
            Dubai. Start your inventory-free e-commerce journey—contact us
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1518893494013-481c1d8ed3fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating/business success
          "https://images.unsplash.com/photo-1627634777217-c864268db30f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Dropshipping concept
          "https://images.unsplash.com/photo-1524508762098-fd966ffb6ef9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Online business
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
